import React, { Suspense, useEffect } from "react"; 
import { getLoggedInUserGUID, getTimeZoneID, getTimeZoneText, GetAssessmentName } from '../../../src/web/components/utils';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import routes from '../config/route';
import Header from '../../web/components/Header';
import SideBar from '../../web/components/SideBar';
import Loader from '../../web/framework/Loader';
import { getLoggedInUser, checkIsAdminPanel, checkIsPatientPanel, checkIsCompanyPanel } from '../../web/components/utils';
import { CheckLogin } from "../../api/apicall";
import { checkPath } from "../../../src/utils";
import Breadcrumb from '../framework/Breadcrumb';
import $ from 'jquery';

const AppRoutes = ({ }) => {
    const { pathname, search } = useLocation();
    const query = new URLSearchParams(search);
    const hideSidebar = query.get('v');

    const navigate = useNavigate();
    const logoutUser = () => {
        localStorage.clear();
        navigate('/');
    };
    const LAYOUT_EXCLUSION = ['', 'home', 'doctorlogin', 'patientlogin', 'adminlogin', 'doctorsignup', 'patientsignup', 'adminsignup', 'forgotpassword', 'register', 'logoutsave', 'registerDetails', 'companylogin', 'adminpatienthealthformNew', 'signthanks', 'resetpassword'];
    const checkLayout = () => {
        const newPathname = pathname.split("/")?.[1];
        return !LAYOUT_EXCLUSION.includes(newPathname);
    };

    useEffect(() => {
        console.log('--App Start--')
        const userLoggedIn = getLoggedInUser()?.LoginSessionKey;
        // if (!checkPath(pathname, 'logoutsave') && !checkPath(pathname, 'registerDetails') && !checkPath(pathname, 'resetpassword')) {
        if (!LAYOUT_EXCLUSION.includes(pathname.split("/")?.[1])) {
            if (!userLoggedIn) {
                navigate('/');
            }
            else {
                // navigate('/dashboard');
            }
        }
    }, [])

    useEffect(() => {
        if (checkLayout()) {
            CheckLogin()
                .then((response: any) => {
                    if(Number(response?.data?.ResponseCode) != 200) {
                        logoutUser();
                    }
                    else{
                        const existingUserData = getLoggedInUser();
                        const latestUserData = response?.data?.Data || {};
                        localStorage.setItem(
                            'userData',
                            JSON.stringify({
                                ...existingUserData,
                                CurrentDate: latestUserData?.CurrentDate,
                            })
                        );
                    }
                })
                .catch((error: any) => {
                    if (Number(error?.response?.data?.ResponseCode) === 501) {
                        logoutUser();
                    }
                });
            console.log('animate')
            $('html, body').animate({
                scrollTop: 0
            }, 1);
        }
    }, [pathname, navigate])

    return (
        <React.Fragment>
            <div className={`${pathname.includes('adminpatienthealthformNew') != true ? "main-wrapper" : ""}`}>
                {
                    checkLayout() &&
                    hideSidebar !== 'false' &&
                    !checkIsAdminPanel(pathname) &&
                    !checkIsPatientPanel(pathname) &&
                    !checkIsCompanyPanel(pathname) &&
                    <React.Fragment>
                        <Header />
                        <SideBar />
                    </React.Fragment>
                }
                {
                    checkIsAdminPanel(pathname) && pathname.split("/")?.[1] !== "adminpatienthealthformNew" && <Header />
                }
                {
                    checkIsPatientPanel(pathname) && <Header />
                }
                {
                    checkIsCompanyPanel(pathname) && <Header />
                }
                {
                    !checkLayout() && pathname.split("/")?.[1] === "registerDetails" &&
                    <Header />
                }
                {
                    checkPath(pathname, 'logoutsave') &&
                    <Header />
                }
                {
                    hideSidebar === 'false' &&
                    <Header />
                }
                <div className={`${(!checkIsAdminPanel(pathname) && !checkIsPatientPanel(pathname) && !checkIsCompanyPanel(pathname)) && hideSidebar !== 'false' ? "page-wrapper" : (pathname.split("/")?.[1] !== "adminpatienthealthformNew") ? "admin-page-wrapper" : ""}`}>
                    {/* {
                        checkLayout() && */}
                    {pathname.includes('adminpatienthealthformNew') != true && <Breadcrumb />}
                    {/* } */}
                    <Suspense fallback={<div><Loader loaderText="Loading" /></div>}>
                        <Routes>
                            {
                                routes?.map(({ path, secured, Component }, key) => {
                                    return (
                                        Array.isArray(path) ?
                                            <React.Fragment key={key}>
                                                {
                                                    path.map((singlePath: string, index: number) => (
                                                        <Route
                                                            key={key}
                                                            path={singlePath}
                                                            element={<Component />}
                                                        />
                                                    ))
                                                }
                                            </React.Fragment>
                                            :
                                            <React.Fragment key={key}>
                                                secured ? (
                                                //Secured root
                                                ): (
                                                <Route
                                                    key={key}
                                                    path={path}
                                                    element={<Component />}
                                                />
                                                )
                                            </React.Fragment>
                                    )
                                })
                            }
                        </Routes>
                    </Suspense>
                </div>
            </div>
        </React.Fragment>
    );
};

export default AppRoutes;